<script setup>
import { UserIcon, UsersIcon, FireIcon } from '@heroicons/vue/24/outline'
import HeadingTwo from '@/Components/HeadingTwo.vue'

const features = [
    {
        name: 'Fyzické osoby s paušálními výdaji',
        description:
            'Pokud podnikáte a používáte paušální výdaje, postaráme se o vaše daňové přiznání, abyste se mohli soustředit na růst vašeho byznysu.',
        href: '#',
        icon: UserIcon,
    },
    {
        name: 'Fyzické osoby s daňovou evidencí',
        description:
            'Máte daňovou evidenci? Nechte na nás všechny administrativní úkony spojené s daňovým přiznáním a soustřeďte se na to, co vám jde nejlépe.',
        href: '#',
        icon: UsersIcon,
    },
    {
        name: 'Zaměstnanci s více pracovními poměry',
        description: 'Máte více zaměstnání a potřebujete zpracovat daňové přiznání? Ušetříme vám čas a zajistíme správnost všech údajů.',
        href: '#',
        icon: FireIcon,
    },
]
</script>

<template>
    <section class="section--width">
        <HeadingTwo value="Pro koho je naše služba ideální?" />

        <div class="mx-auto mt-4 max-w-2xl sm:mt-8 lg:max-w-none">
            <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-4 lg:max-w-none lg:grid-cols-3 lg:gap-y-16">
                <div
                    v-for="feature in features"
                    :key="feature.name"
                    class="card flex flex-col"
                >
                    <dt class="font-roboto text-lg/7 font-bold tracking-wide text-black dark:text-white">
                        <div class="mb-6 flex size-10 items-center justify-center rounded-lg bg-white dark:bg-zinc-900">
                            <component
                                :is="feature.icon"
                                class="size-7 text-cyan-500"
                                aria-hidden="true"
                            />
                        </div>

                        {{ feature.name }}
                    </dt>

                    <dd class="mt-5 flex flex-auto flex-col text-base/7 text-gray-700 dark:text-gray-300">
                        <p class="flex-auto">
                            {{ feature.description }}
                        </p>
                    </dd>
                </div>
            </dl>
        </div>
    </section>
</template>
